import React, { memo } from 'react';
import { motion } from 'framer-motion';

const INTERVALS = ['2nd', '3rd', '4th', '5th', '6th', '7th', 'Octave'];

const IntervalButtons = memo(function IntervalButtons({ 
  onSelect, 
  feedbackInterval, 
  feedbackType, 
  disabled 
}) {
  return (
    <div 
      className="w-full flex flex-col"
      data-testid="interval-buttons"
    >
      {/* Red/Coral band at top with shadows - matching piano keyboard */}
      <div className="relative flex-shrink-0">
        {/* Shadow above the band */}
        <div 
          className="absolute inset-x-0 top-0 h-1 z-10 pointer-events-none"
          style={{
            background: 'linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, transparent 100%)'
          }}
        />
        {/* The coral band - 8px */}
        <div 
          className="h-2 w-full"
          style={{ backgroundColor: '#CC7A6F' }}
        />
        {/* Shadow below the band */}
        <div 
          className="absolute inset-x-0 -bottom-1 h-2 z-10 pointer-events-none"
          style={{
            background: 'linear-gradient(to bottom, rgba(0,0,0,0.08) 0%, transparent 100%)'
          }}
        />
      </div>
      
      {/* Buttons area with dark background matching piano */}
      <div className="bg-black/80 py-6 px-4">
        {/* Top row - 4 buttons */}
        <div className="flex justify-center gap-3 mb-3">
          {INTERVALS.slice(0, 4).map((interval) => (
            <motion.button
              key={interval}
              onClick={() => !disabled && onSelect(interval)}
              disabled={disabled}
              className={`
                px-6 py-3 rounded-lg font-sans font-medium text-base
                transition-all duration-150
                ${feedbackInterval === interval 
                  ? feedbackType === 'correct'
                    ? 'bg-sage-500 text-white scale-105'
                    : 'bg-coral-500 text-white scale-95'
                  : 'bg-coral-400 text-cream-100 hover:bg-coral-300 active:bg-coral-500'
                }
                ${disabled && feedbackInterval !== interval ? 'opacity-50' : ''}
              `}
              whileTap={{ scale: disabled ? 1 : 0.95 }}
              data-testid={`interval-btn-${interval.toLowerCase()}`}
            >
              {interval}
            </motion.button>
          ))}
        </div>
        
        {/* Bottom row - 3 buttons */}
        <div className="flex justify-center gap-3">
          {INTERVALS.slice(4).map((interval) => (
            <motion.button
              key={interval}
              onClick={() => !disabled && onSelect(interval)}
              disabled={disabled}
              className={`
                px-6 py-3 rounded-lg font-sans font-medium text-base
                transition-all duration-150
                ${feedbackInterval === interval 
                  ? feedbackType === 'correct'
                    ? 'bg-sage-500 text-white scale-105'
                    : 'bg-coral-500 text-white scale-95'
                  : 'bg-coral-400 text-cream-100 hover:bg-coral-300 active:bg-coral-500'
                }
                ${disabled && feedbackInterval !== interval ? 'opacity-50' : ''}
              `}
              whileTap={{ scale: disabled ? 1 : 0.95 }}
              data-testid={`interval-btn-${interval.toLowerCase()}`}
            >
              {interval}
            </motion.button>
          ))}
        </div>
      </div>
    </div>
  );
});

export default IntervalButtons;
